export default {
  path: '/requests',
  name: 'requests',
  redirect: { name: 'requests.list-page' },
  component: () =>
    import(/* webpackChunkName: "requests" */ '@/views/requests/index.vue'),
  children: [
    {
      path: '/requests',
      name: 'requests.list-page',
      component: () =>
        import(
          /* webpackChunkName: "requests-page" */ '@/views/requests/RequestsPage.vue'
        )
    },
    {
      path: '/request/templates',
      name: 'request.templates-page',
      component: () =>
        import(
          /* webpackChunkName: "request-templates-page" */ '@/views/requests/RequestTemplatesPage.vue'
        )
    },
    {
      path: '/request/create',
      name: 'request.new-page',
      component: () =>
        import(
          /* webpackChunkName: "request-new-page" */ '@/views/requests/NewRequestPage.vue'
        )
    },
    {
      path: '/request/file/:fileRequestUserId/templates',
      name: 'request.request-file-templates-page',
      component: () =>
        import(
          /* webpackChunkName: "request-request-file-templates-page" */ '@/views/templates/TemplatesPage.vue'
        )
    },
    {
      path: '/request/file/:fileRequestUserId/template/:id',
      name: 'request.request-file-template-form-page',
      component: () =>
        import(
          /* webpackChunkName: "request-request-file-template-form-page" */ '@/views/templates/TemplateFormPage.vue'
        )
    },
    {
      path: '/request/file/:fileRequestUserId/create',
      name: 'request.request-file-new-page',
      component: () =>
        import(
          /* webpackChunkName: "request-request-file-new-page" */ '@/views/file/NewFilePage.vue'
        )
    },
    {
      path: '/request/to/:id',
      name: 'request.view-requested-to-page',
      component: () =>
        import(
          /* webpackChunkName: "request-view-to-page" */ '@/views/requests/ViewRequestedToPage.vue'
        )
    },
    {
      path: '/request/by/:id',
      name: 'request.view-requested-by-page',
      component: () =>
        import(
          /* webpackChunkName: "request-view-by-page" */ '@/views/requests/ViewRequestedByPage.vue'
        )
    },
    {
      path: '/request/:id/edit',
      name: 'request.edit-requested-to-page',
      component: () =>
        import(
          /* webpackChunkName: "request-edit-to-page" */ '@/views/requests/EditRequestedToPage.vue'
        )
    },
    {
      path: '/requests/files',
      name: 'request.files-page',
      component: () =>
        import(
          /* webpackChunkName: "request-edit-to-page" */ '@/views/requests/RequestsFilesPage.vue'
        )
    },
    {
      path: '/requests/files/:id',
      name: 'request.view-file-page',
      component: () =>
        import(
          /* webpackChunkName: "request-view-file-page" */ '@/views/requests/ViewRequestsFilePage.vue'
        )
    }
  ]
}
